import React, { FC, useEffect } from 'react';

import { useUnit } from 'effector-react';

import * as Collapsible from '@radix-ui/react-collapsible';

import {
    $isToplineVisible,
    $toplineText,
    setToplineVisible,
    toplineMounted,
} from '@stores/topline';

import { applyTypograf } from '@utils/typograf';

import { Container } from '@components/common/Container/Container';
import { CancelIcon } from '@components/icons/CancelIcon';

import styles from './Topline.module.scss';

export const Topline: FC = () => {
    const [{ isOpen }, setOpen, topline_text, onToplineMounted] = useUnit([
        $isToplineVisible,
        setToplineVisible,
        $toplineText,
        toplineMounted,
    ]);

    useEffect(() => {
        onToplineMounted();
    }, [topline_text, onToplineMounted]);

    return (
        <Collapsible.Root open={isOpen} onOpenChange={setOpen} asChild>
            <Collapsible.Content className={styles.collapsibleContent}>
                <Container classes={{ root: styles.root }}>
                    <div className={styles.text}>{topline_text && applyTypograf(topline_text)}</div>
                    <Collapsible.Trigger asChild>
                        <button type="button" className={styles.button}>
                            <CancelIcon className={styles.icon} />
                        </button>
                    </Collapsible.Trigger>
                </Container>
            </Collapsible.Content>
        </Collapsible.Root>
    );
};
